import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import moment from 'moment';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { SearchtoolboxService } from "../_services/searchtoolbox.service";
import { PersonSearchService } from '../_services/person-search.service';
import { DataService } from 'src/app/data.service';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';
import { SaveSearchModalComponent } from '../save-search-modal/save-search-modal.component';
import * as _ from 'underscore';
import { GeneralConstants } from '../constants/GeneralConstants';
import { HashService } from '../_services/hash.service';
import { JdDataService } from '../jd-data.service';
import { JobDescriptionKeys } from '../common-interfaces-classes/JobDescriptionKeys';
import { GlobalService } from '../_services/global.service';
import { SaveSearchPersmissionModalComponent } from '../save-search-persmission-modal/save-search-persmission-modal.component';
import { LoginService } from '../_services/login.service';
import cjson from 'compressed-json';
import { AggregationService } from '../_services/aggregation.service';
import { TalentInsightsService } from '../_services/talent-insights.service';
import { FilterDataHandlerService } from '../_services/filter-data-handler.service';


@Component({
    selector: 'app-search-history',
    templateUrl: './search-history.component.html',
    styleUrls: ['./search-history.component.scss'],
    standalone: false
})
export class SearchHistoryComponent implements OnInit {

  @Input() save: boolean = false;
  @Input() calledFrom:any;
  @Input() events: Observable<void>
  @Input() calledForHistory :any;
  @Input() calledForSaveSearch :any;
  @Input() openModal: boolean = false;

  starthistory: any = 0;
  @Output() viewHistoryUpdate :  EventEmitter<any> = new EventEmitter();
  @Output() viewSavedHistoryUpdate :  EventEmitter<any> = new EventEmitter();

  @ViewChild('historymodal') historymodal: TemplateRef<any>;
  @ViewChild('deleteSavedSearchModal') deleteSavedSearchModal: TemplateRef<any>;

  searchToolboxHistory: any[] = [];
  searchHistoryLoader: boolean = false;
  currentUserId: number | string = null;
  successMessage: string = null;
  errorMessage: string = null;
  deleteModalRef: NgbModalRef = null;
  savedSearchToDelete: any = null;
  role: string = null;
  isTalentInsightsPage: boolean = false;


  @Input() currentModule: string = 'personsearch';
  members: any[] = [];
  // savedSearchList:any[]= [{
  //   // savedInsight:'Saved Insights',
  //   headers:['Saved Insights','Generated From','Created On'],
  //   items:[{name:'Software Engineer', geneFrom:'Job description',created:'2026-01-10T09:30:00'},{name:'Software Engineer', geneFrom:'Job description',created:'2026-01-10T09:30:00'},{name:'Software Engineer', geneFrom:'Job description',created:'2026-01-10T09:30:00'},{name:'Software Engineer', geneFrom:'Job description',created:'2026-01-10T09:30:00'},{name:'Software Engineer', geneFrom:'Job description',created:'2026-01-10T09:30:00'},{name:'Software Engineer', geneFrom:'Job description',created:'2026-01-10T09:30:00'}]
  // }]
  constructor( private router: Router,
               private personSearchService: PersonSearchService,
               private _localstorageservice: LocalStorageService,
               private dataService: DataService,
               private modalService: NgbModal,
               private hashService: HashService,
               private jdDataService: JdDataService,
               private loginService: LoginService,
               private aggregationService: AggregationService,
               private talentInsightsService: TalentInsightsService,
               private filterDataHandlerService: FilterDataHandlerService
             ){}

  ngOnInit() {
    this.currentUserId = this._localstorageservice.getItem('userid');
    this.role = this._localstorageservice.getItem('role');
    this.isTalentInsightsPage = this.filterDataHandlerService.isTalentpoolInsights;

    if(this.events){
      this.events.subscribe((ev:any) => {
        if(ev === 'REFRESH') {
          this.gethistory(null, true);
        } else {
          this.openHistoryModal()
        }
      })
    }

    this.gethistory();
  }

  formatDate(x) {
    return moment(x).format('Do MMM YY | hh:mm A')
  }

  /**Used to get module name used for query param */
  getHistoryModuleName(){
    if(this.currentModule == 'talent-insights'){
      return GlobalService.HISTORY_MODULE.TALENT_INSIGHTS;
    } else if(this.currentModule === 'company-insights'){
      return GlobalService.HISTORY_MODULE.COMPANY_INSIGHTS;
    } else{
      return GlobalService.HISTORY_MODULE.PERSON_SEARCH;
    }
  }

  gethistory(data: any = null, saveMode: boolean = false) {

    this.searchHistoryLoader = true;
    if(data == 'pagination'){
      this.starthistory = this.starthistory + 10
    }else {
      this.searchToolboxHistory = []
    }
    this.searchHistoryLoader = true;

    this.personSearchService[(this.save || saveMode || this.calledForSaveSearch == 'saveSearch') ? 'getSaveSearchHistory' : 'getSearchHistory'](this.starthistory, this.getHistoryModuleName()).subscribe((result: any) => {
    this.searchHistoryLoader = false;
      if(result && result.status == 'success' && result.message && Array.isArray(result.message) && result.message.length){
        if(data == 'pagination')
        this.searchToolboxHistory = this.searchToolboxHistory.concat(result.message)
        else
        this.searchToolboxHistory = result.message;
        this.searchToolboxHistory = this.searchToolboxHistory.map(obj => {
          const title = this.modifyQuery(obj.query);
            if(title?.length)
              return { ...obj, title };
      });
      this.searchToolboxHistory = this.searchToolboxHistory.filter(Boolean);
      this[(this.save || this.calledForSaveSearch == 'saveSearch') ? 'viewSavedHistoryUpdate' : 'viewHistoryUpdate'].emit(this.searchToolboxHistory)
        // this.saveHistory = this.searchToolboxHistory.filter(x => x.issaved == 1)
      }
      this.getAllTeamMembers();
    });


  }


  searchFromHistory(history){
    console.log(history, 'history')
    const hasEUPSAccess = this._localstorageservice.getItem('hasEUPersonSearchAccess');
    const hasEUTIAccess = this._localstorageservice.getItem('hasEUTalentInsightsAccess')
    this.modalService.dismissAll();
    const query = JSON.parse(history.query);
    console.log('query quesry', query);
    if((hasEUTIAccess && !hasEUPSAccess) && query?.continentstobeincluded == 'europe' && this.getHistoryModuleName() == 'personsearch ') {
      this.errorMessage = 'Europe access denied';
      setTimeout(() => this.errorMessage = '', 5000);
    } else if((!hasEUTIAccess && hasEUPSAccess) && query?.continentstobeincluded == 'europe' && this.getHistoryModuleName() == 'talentinsights') {
      this.errorMessage = 'Europe access denied';
      setTimeout(() => this.errorMessage = '', 5000);
    }
    else {
      if(query && !query.hasOwnProperty('talentdiscoveryhistoryid')){
        query['talentdiscoveryhistoryid'] = history.talentdiscoveryhistoryid
      }

      if(query && query.hasOwnProperty('job_description_keys') && this.currentModule === 'personsearch'){
        console.log('job_description_keys', query.job_description_keys);
        query.preferredskills = query?.job_description_keys?.skills || [];
        query.jobtitles = query?.job_description_keys?.job_titles.concat(query?.job_description_keys?.mandatory_job_titles) || [];
        query.industries = query?.job_description_keys?.industries.concat(query?.job_description_keys?.mandatory_industries) || [];
        query.location = query?.job_description_keys?.locations.concat(query?.job_description_keys?.mandatory_locations) || [];
        query.companies = query?.job_description_keys?.companies || [];
        query.mandatoryskills = query?.job_description_keys?.mandatory_skills || [];
        query.companysizes = query?.job_description_keys?.company_sizes || [];
        query.fromyearsofexperience = query?.job_description_keys?.fromYrsOfExperience ? [query?.job_description_keys?.fromYrsOfExperience]  : [];
        query.toyearsofexperience = query?.job_description_keys?.toYrsOfExperience ? [query?.job_description_keys?.toYrsOfExperience]  : [];
        delete query.job_description_keys;
      }

      const allLists = {
        jobTitleSelectedList: this.addKeyToArray(query, 'jobtitle'),
        pastJobTitleSelectedList: this.addKeyToArray(query, 'pastjobtitle'),
        skillsSelectedList: this.addKeyToArray(query, 'skills'),
        industrySelectedList: this.addKeyToArray(query, 'industry'),
        locationSelectedList: this.addKeyToArray(query, 'location'),
        companySelectedList: this.addKeyToArray(query, 'companies'),
        companyids: this.addKeyToArray(query, 'companyids'),
        educationSelectedList: this.addKeyToArray(query.educationaldegrees),
        fieldOfStudySelectedList: this.addKeyToArray(query.educationalmajors),
        schoolSelectedList: this.addKeyToArray(query.schools),
        schoolLocationSelectedList: this.addKeyToArray(query, 'schoollocation'),
        // gender: this.gender,
        // contactsAvailableArray: contactsAvailableArray,
        // contactSelectedList: contactSelectedList,
        yearsofexperienceFrom: query.fromyearsofexperience && query.fromyearsofexperience.length ? query.fromyearsofexperience[0] : null,
        yearsofexperienceTo: query.toyearsofexperience && query.toyearsofexperience ? query.toyearsofexperience[0] : null,
        companyStatus: query?.companytype?.toString()?.toLocaleLowerCase() == 'all' ? 'Current or Past' :  this.capitalizeFirstLetter(query.companytype),
        jobTitleStatus: query?.jobtitletype?.toString()?.toLocaleLowerCase() == 'all' ? 'Current or Past' :  this.capitalizeFirstLetter(query.jobtitletype),
        industryStatus: query?.industrytype?.toString()?.toLocaleLowerCase() == 'all' ? 'Current or Past' :  this.capitalizeFirstLetter(query.industrytype),
        yearsofexperience: this.capitalizeFirstLetter(query.experiencetype),
        companysize : this.addKeyToArray(query.companysizes, "companysize"),
        gender: this.getGenderResult(query.gender),
        filterLikelyToMoveIn: (query.likelytomovetype == null || query.likelytomovetype.toString().toLowerCase() == 'all') ? 'All' : this.capitalizeFirstLetter(query.likelytomovetype),
        continentstobeincluded: query.continentstobeincluded.toString().split('; ') || null,
        functionSelectedList: this.addKeyToArray(query, 'functions'),
        seniority:  query.seniority && query.seniority.length ? this.addKeyToArray(query.seniority, "seniority"): [],
        fullNameSelectedList: query?.fullnames && query?.fullnames.length ? this.addKeyToArray(query.fullnames): [],
        changedjobsstartdurationinmonths: query?.changedjobsstartdurationinmonths || 0,
        changedjobsenddurationinmonths: query?.changedjobsenddurationinmonths || 12,
        changedjobs: (query?.changedjobs === 'no' && (!(query?.changedjobsstartdurationinmonths) || query?.changedjobsstartdurationinmonths === 0)) ? null : query?.changedjobs,

        distancefromselectedlocationsmeasurementunit: query?.distancefromselectedlocationsmeasurementunit,
        distancefromselectedlocations: query?.distancefromselectedlocations,
        currentfromyearsofexperience: query.currentfromyearsofexperience && query.currentfromyearsofexperience.length ? query.currentfromyearsofexperience[0] : null,
        currenttoyearsofexperience: query.currenttoyearsofexperience && query.currenttoyearsofexperience ? query.currenttoyearsofexperience[0] : null,
        profilehighlights: query?.profilehighlights ? query?.profilehighlights.split('; ') : [],
        positionhierarchies: query?.positionhierarchies ? this.addKeyToArray(query.positionhierarchies, "position"): [],
        tograduationyear: query?.tograduationyear,
        fromgraduationyear: query?.fromgraduationyear,
        nlsearchquery: query?.nlsearchquery,
        locationcontinents: query?.locationcontinents,
        job_search_keys: query?.job_search_keys,
        booleanquery: query?.booleanquery,
        screeningCriteria: query?.screeningCriteria ? JSON.parse(query?.screeningCriteria) : [],
        // Full AI-suggested pool, restored so the Edit Criteria panel can show the remaining suggestions again
        screeningCriteriaSuggestions: query?.screeningCriteriaSuggestions ? JSON.parse(query?.screeningCriteriaSuggestions) : [],
        excluded_persons: query?.exclude_persons && query?.exclude_persons.length ? [query?.exclude_persons] : [],
  similarcandidates_excludefirstname: query?.similarcandidates_excludefirstname ? query?.similarcandidates_excludefirstname : '',
  similarcandidates_excludelastname: query?.similarcandidates_excludelastname ? query?.similarcandidates_excludelastname : '',
  similarcandidates_jobtitles: query?.similarcandidates_jobtitles ? query?.similarcandidates_jobtitles : [],
  similarcandidates_companies: query?.similarcandidates_companies ? query?.similarcandidates_companies : [],

      };

      if((query.linkedinurl !== '' && query.linkedinurl !== null) || query.isUploadedFromResume === true){
        allLists['isSimilarCanidate'] = true
        allLists['similarCanidateFullName'] = query.fullname
        allLists['hideSearchBox'] = false
        const totalTenure = query.similarcandidates_totaltenure || 0;
        const fromYrsOfExperience = query.similarcandidates_fromyearsofexperience ? query.similarcandidates_fromyearsofexperience : (parseInt(totalTenure) - (parseInt(totalTenure) * 0.25));
        const toYrsOfExperinece = query.similarcandidates_toyearsofexperience ? query.similarcandidates_toyearsofexperience : (parseInt(totalTenure) + (parseInt(totalTenure) * 0.25));

        allLists['similarobject'] = {
          ['data'] : {
          jobtitle: (query.similarcandidates_jobtitles && query.similarcandidates_jobtitles.length && query.newsimilarcandidateflow) ? query.similarcandidates_jobtitles.split(";").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_jobtitles && query.similarcandidates_jobtitles.length && !query.newsimilarcandidateflow ? query.similarcandidates_jobtitles.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: true })) : [],
          jobindustryname:  (query.similarcandidates_industries && query.similarcandidates_industries.length && query.newsimilarcandidateflow) ? query.similarcandidates_industries.split("; ").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_industries && query.similarcandidates_industries.length && !query.newsimilarcandidateflow ? query.similarcandidates_industries.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: true })) : [],
          companysize: (query.similarcandidates_companysizes && query.similarcandidates_companysizes.length && query.newsimilarcandidateflow) ? query.similarcandidates_companysizes.split("; ").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_companysizes && query.similarcandidates_companysizes.length && !query.newsimilarcandidateflow ? query.similarcandidates_companysizes.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: false })) : [],
          skills: (query.similarcandidates_skills && query.similarcandidates_skills.length && query.newsimilarcandidateflow) ? query.similarcandidates_skills.split(";").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_preferredskills && query.similarcandidates_preferredskills.length && !query.newsimilarcandidateflow ? query.similarcandidates_preferredskills.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: false })) : [],
          currentlocation: (query.similarcandidates_locations && query.similarcandidates_locations.length && query.newsimilarcandidateflow) ? query.similarcandidates_locations.split("; ").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_locations && query.similarcandidates_locations.length && !query.newsimilarcandidateflow ? query.similarcandidates_locations.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: false })) : [],
          jobcompanyname: (query.similarcandidates_companies && query.similarcandidates_companies.length && query.newsimilarcandidateflow) ? query.similarcandidates_companies.split("; ").map(j => JSON.parse(j)).filter(Boolean) : query.similarcandidates_companies && query.similarcandidates_companies.length && !query.newsimilarcandidateflow ? query.similarcandidates_companies.split("; ").filter(Boolean).map(a => ({ key: a, isMandatory: false })) : [],
          linkedinurl: query.linkedinurl,
          isUploadedFromResume: query.isUploadedFromResume ? true : false,
          totaltenure: query.similarcandidates_totaltenure,
          elasticid: query.exclude_persons && typeof query.exclude_persons === 'object' ? query.exclude_persons[0] : query.exclude_persons,
          fullname: query.fullname != '' ? query.fullname : '',
          changedjobsstartdurationinmonths: query?.changedjobsstartdurationinmonths || 0,
          changedjobsenddurationinmonths: query?.changedjobsenddurationinmonths || 12,
          changedjobs: (query?.changedjobs === 'no' && (!(query?.changedjobsstartdurationinmonths) || query?.changedjobsstartdurationinmonths === 0)) ? null : query?.changedjobs,
          distancefromselectedlocationsmeasurementunit: query?.distancefromselectedlocationsmeasurementunit,
          distancefromselectedlocations: query?.distancefromselectedlocations,
          locationcontinent: query.continentstobeincluded || null,
          fromYrsOfExperience,
          toYrsOfExperinece
        }
      }
      }


      for (const key in allLists) {
        if (allLists.hasOwnProperty(key) && allLists[key] === undefined) {
            allLists[key] = []
        }
      }

      let data = {
        allLists: allLists,
        requestObject: this.modifyRequestObject(query),
         calledFrom: 'history',
      }
      console.log('search history', data);

      let keyword = ''
      if(query.booleanquery !== '*'){
        keyword = query.booleanquery
      }
      this.dataService.setData(data);
      let queryParams = {}
      queryParams['keyword'] = keyword
      queryParams['searchSource'] = 'history-component';
      if(query && query.searchedfrom !== ''){
        queryParams['type'] = query.searchedfrom;
        if(allLists?.nlsearchquery && allLists?.nlsearchquery.length) {
          queryParams['type'] = 'nl-search';
        }
      }
      if(history && history.issaved == 1) {
        queryParams['talentdiscoveryhistoryid'] = history.talentdiscoveryhistoryid;
        this._localstorageservice.setItem('saveSearchName', history.talentdiscoveryname)
      }
      if (query?.searchedfrom === GeneralConstants.REDIRECT_SOURCES.JOB_DESCRIPTION) {
        // Only getSimilarObjFromHistory method should be needed to be updated once I update the logic in backend...
        query.continentstobeincluded && this._localstorageservice.setItem("similar-region", query.continentstobeincluded);
        const similarObject = this.jdDataService.getSimilarObjFromHistory(query);
        const uniqueHash = this.hashService.generateUniqueHash();
        this.jdDataService.setSessionData(uniqueHash, similarObject);
        queryParams['uniqueHash'] = uniqueHash;
      }
      if(this.currentModule == 'talent-insights'){
        const localKey = GlobalService.hash(JSON.stringify(cjson.compress(data)))
          localStorage.setItem(localKey, JSON.stringify(cjson.compress(data)));
          queryParams['key'] = localKey;
              this.router.navigate(['/talent-insights/overview'], { queryParams: queryParams });


      } else if(this.currentModule == 'personsearch'){
        if(queryParams['type'] == 'quick-search' || queryParams['type'] == 'advanced-search' || queryParams['type'] == 'job-description' || queryParams['type'] == 'nl-search' || !queryParams['type'] || queryParams['type'] == 'similar-candidate-from-linkedinurl' || queryParams['type'] == 'similar-candidate-resume-upload') {

          const localKey = GlobalService.hash(JSON.stringify(cjson.compress(data)))
          localStorage.setItem(localKey, JSON.stringify(cjson.compress(data)));
          queryParams['key'] = localKey;
          this.router.navigate(['/candidate-list'], { queryParams: queryParams });
        } else {
          this.router.navigate(['/candidate-list'], { queryParams: queryParams });
        }
      }
    }

  }
  addKeyToArray(data: any, type: any = null) {
    if (data != null) {
      let modifiedData = []
      if (type == 'skills') {
        if (data.preferredskills && data.preferredskills.length) {
          let preferredskills = data.preferredskills.split('; ').map(v => Object.assign({ key: v, isMandatory: false, isExcluded: false, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'skill', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          preferredskills.forEach(element => modifiedData.push(element));
        }

          if (data.exclude_preferredskills && data.exclude_preferredskills.length) {
          let excludePreferredSkills = data.exclude_preferredskills.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, isMandatory: false, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'skill', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          excludePreferredSkills.forEach(element => modifiedData.push(element));
        }


        if (data.mandatoryskills && data.mandatoryskills.length) {
          let mandatoryskills = data.mandatoryskills.split('; ').map(v => Object.assign({ key: v, isMandatory: true, isExcluded: false, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'skill', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          mandatoryskills.forEach(element => modifiedData.push(element));

        }

       if (data.exclude_mandatoryskills && data.exclude_mandatoryskills.length) {
          let excludeMandatorySkills = data.exclude_mandatoryskills.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, isMandatory: true, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'skill', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          excludeMandatorySkills.forEach(element => modifiedData.push(element));
        }
        return modifiedData;
      } else if (type == 'jobtitle') {
        if (data.jobtitles && data.jobtitles.length) {
          let preferredJobList = data.jobtitles.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'title', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          preferredJobList.forEach(element => modifiedData.push(element));
        }

        if (data.exclude_jobtitles && data.exclude_jobtitles.length) {
          let excludedJobList = data.exclude_jobtitles.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'title', key: this.getSafeKey(v.replace('.aisearch', '')) } }));
          excludedJobList.forEach(element => modifiedData.push(element));
        }

        return modifiedData;

      } else if (type == 'location') {
        if (data.locations && data.locations.length) {
          let preferredLocation = data.locations.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.includes('.aisearch') ? v.replace('.searchastext', '').replace('.iplocation', '').replace('.aisearch', '').split(',')[0].trim() : v.replace('.searchastext', '').replace('.iplocation', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch') })).filter(l => !l.key.includes('.iplocation'))
          preferredLocation.forEach(element => modifiedData.push(element));
        }
        if (data.exclude_locations && data.exclude_locations.length) {
          let excludedLocation = data.exclude_locations.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.includes('.aisearch') ? v.replace('.searchastext', '').replace('.iplocation', '').replace('.aisearch', '').split(',')[0].trim() : v.replace('.searchastext', '').replace('.iplocation', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch') }));
          excludedLocation.forEach(element => modifiedData.push(element));
        }
        return modifiedData;

      } else if (type == 'companies') {
        if (data.companies && data.companies.length) {
          let preferredCompanies = data.companies.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch') }));

          preferredCompanies.forEach(element => modifiedData.push(element));
        }
        if (data.exclude_companies && data.exclude_companies.length) {

          let excludedCompanies = data.exclude_companies.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch') }));

          excludedCompanies.forEach(element => modifiedData.push(element));

        }
        return modifiedData;
      } else if( type == 'companyids'){
        if(data.companyids && data.companyids.length){
          return data.companyids.toString().split('; ');
        }
      } else if (type == "companysize") {
        let preferredCompanieSize = data.toString().split('; ').map(item => item.trim());
        preferredCompanieSize.forEach(element => {
          modifiedData.push(element)
        })
        return modifiedData;
      } else if (type == "seniority") {
        let preferredSeniority = data.toString().split('; ').map(item => item.trim());
        preferredSeniority.forEach(element => {
          modifiedData.push(element)
        })
        return modifiedData;
      } else if (type === "pastjobtitle") {
        if (data.pastjobtitles && data.pastjobtitles.length) {
          let preferredPastJobList = data.pastjobtitles.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'title', key: this.getSafeKey(v.replace('.aisearch', '')) }  }));
          preferredPastJobList.forEach(element => modifiedData.push(element));
        }

        if (data.exclude_pastjobtitles && data.exclude_pastjobtitles.length) {
          let excludedPastJobList = data.exclude_pastjobtitles.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '').replace('.aisearch', ''), isSuggested: v.includes('.aisearch'), suggestedTitle: { name: v.replace('.aisearch', ''), selected: true, type: 'title', key: this.getSafeKey(v.replace('.aisearch', '')) }  }));
          excludedPastJobList.forEach(element => modifiedData.push(element));
        }
      } else if (type == 'industry') {
        if (data.industries && data.industries.length) {
          let industryList = data.industries.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '') }));
          industryList.forEach(element => modifiedData.push(element));
        }

        if (data.exclude_industries && data.exclude_industries.length) {
          let excludedIndustryList = data.exclude_industries.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '') }));
          excludedIndustryList.forEach(element => modifiedData.push(element));
        }
      return modifiedData;

    } else if (type == 'schoollocation') {
      if (data.schoollocation && data.schoollocation.length) {
        let schoollocationList = data.schoollocation.toString().split(';').map(v => Object.assign({ key: v.trim(), isExcluded: false, chipkey: v.replace('.searchastext', '').trim() }));
        schoollocationList.forEach(element => modifiedData.push(element));
      }

        if (data.exclude_schoollocation && data.exclude_schoollocation.length) {
          let excludedschoollocationList = data.exclude_schoollocation.toString().split(';').map(v => Object.assign({ key: v.trim(), isExcluded: true, chipkey: v.replace('.searchastext', '').trim() }));
          excludedschoollocationList.forEach(element => modifiedData.push(element));
        }
        return modifiedData;
      }
      else if(type == 'position') {
        let position = data.toString().split('; ').map(item => item.trim());
        position.forEach(element => {
          modifiedData.push(element)
        })
        return modifiedData;
      }
      else if (type == 'functions') {
        if (data.functions && data.functions.length) {
          let functionsList = data.functions.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: false, chipkey: v.replace('.searchastext', '') }));
          functionsList.forEach(element => modifiedData.push(element));
        }

        if (data.exclude_functions && data.exclude_functions.length) {
          let excludedFunctions = data.exclude_functions.toString().split('; ').map(v => Object.assign({ key: v, isExcluded: true, chipkey: v.replace('.searchastext', '') }));
          excludedFunctions.forEach(element => modifiedData.push(element));
        }
      return modifiedData;

    }
      else {
        modifiedData = data.split('; ').map(v => Object.assign({ key: v, chipkey: v.replace('.searchastext', '').replace('.aisearch', '').replace('.iplocation', '') }));
      }
      return modifiedData;
    }
  }

  private getJdDataFromPayload(payload) {
    const jdData: JobDescriptionKeys = payload?.job_description_keys;
    for (const key in jdData) {
      jdData[key] = this.splitIfString(jdData[key]);
    }
    return jdData;
  }

  private splitIfString(el) {
    if (typeof el === "string") {

      return el.split(";").map(el => el.trim().replace('.searchastext', '').replace('.aisearch', '').replace('.iplocation', ''));
    }
    if (Array.isArray(el))
      return el;
    return [];
  }

private stringifyFilters(jdFilterData: JobDescriptionKeys) {
  const parts: string[] = [];

  for (const key in jdFilterData) {
    const value = jdFilterData[key];

    if (!value || (Array.isArray(value) && value.length === 0)) continue;

    let formattedValue = '';

    if (Array.isArray(value)) {
      formattedValue = value.join(', ');
    } else {
      formattedValue = value;
    }

    parts.push(`${GeneralConstants.JD_FILTER_KEY_NAME_MAP[key]} : ${formattedValue}`);
  }

  return parts.join(', ');
}

  modifyQuery(query){
    const payload = JSON.parse(query);
    const jdFilterData = this.getJdDataFromPayload(payload);
    let jdFilterHistory = "";
    if (!_.isEmpty(jdFilterData)) {
      jdFilterHistory = this.stringifyFilters(jdFilterData);
    }

    const modifedPayload = this.modifyQueryForUi(payload)
    let formattedString = ''
    let originalFormattedString = ''
    if(modifedPayload){
      if(modifedPayload.jobtitles && modifedPayload.jobtitles.length){
        formattedString = formattedString  + ` | Job Title : ${modifedPayload.jobtitles.map(x=>{x=x.replace('.searchastext','').replace('.aisearch', '');return x;}).join(', ')}`
        if(this.currentModule != "talent-insights"){
          formattedString += `(${modifedPayload.jobtitletype === 'all' || modifedPayload.jobtitletype === 'All' ? 'Current or past' : modifedPayload.jobtitletype})`
        }
      }
      if (modifedPayload.pastjobtitles && modifedPayload.pastjobtitles.length) {
        formattedString = formattedString + ` | Past Job Title : ${modifedPayload.pastjobtitles.map(x => { x = x.replace('.searchastext', '').replace('.aisearch', ''); return x; }).join(', ')}`
      }
      if (modifedPayload.exclude_pastjobtitles && modifedPayload.exclude_pastjobtitles.length) {
        formattedString = formattedString + ` | Excluded Past Jobtitles: ${modifedPayload.exclude_pastjobtitles.map(x => { x = x.replace('.searchastext', '').replace('.aisearch', ''); return x; }).join(',')}`
      }
      if (modifedPayload.preferredskills && modifedPayload.preferredskills.length) {
          formattedString += ` | Skills: ${modifedPayload.preferredskills.map(x=>{x=x.replace('.searchastext','').replace('.aisearch', '');return x;}).join(', ')}\n`;
      }

        if (modifedPayload.exclude_preferredskills && modifedPayload.exclude_preferredskills.length) {
        formattedString = formattedString + ` | Excluded Preferred Skills: ${modifedPayload.exclude_preferredskills.map(x => { x = x.replace('.searchastext', '').replace('.aisearch', ''); return x; }).join(',')}`
      }

      if (modifedPayload.exclude_mandatoryskills && modifedPayload.exclude_mandatoryskills.length) {
        formattedString = formattedString + ` | Excluded Mandatory Skills: ${modifedPayload.exclude_mandatoryskills.map(x => { x = x.replace('.searchastext', '').replace('.aisearch', ''); return x; }).join(',')}`
      }

      if (_.flatten(modifedPayload.companysizes) && Array.isArray(modifedPayload.companysizes) && modifedPayload.companysizes.length) {
        let mofifiedD =[]
          let data =modifedPayload.companysizes.map(item => item.trim())
        if(data.includes("All")){
          mofifiedD = ["All"]
          }else{
            mofifiedD=data;
          }
          if(mofifiedD.length){
            formattedString += ` | Company Size: ${mofifiedD.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')}\n`;
          }
      }
      if(modifedPayload.locations && modifedPayload.locations.length){
        const location = modifedPayload.locations.filter(l => !l.includes('.iplocation')).map(x => {
          x = x.includes('.aisearch') ? x.split(',')[0].trim() : x;
          x = x.replace('.searchastext','').replace('.iplocation', '').replace('.aisearch', '');
          return x;
        });
        formattedString += location && location.length ? ` | Location: ${location.join(':')}` : '';
        if(modifedPayload?.distancefromselectedlocations){
          formattedString += ` | Distance : ${modifedPayload.distancefromselectedlocations} ${modifedPayload.distancefromselectedlocationsmeasurementunit}`;
        }
      }
      if(modifedPayload.profilehighlights.length){

        /**Used to map values from labels, keys are values which was sent in payload, and values are frontend lables */
        const MappingObject = {
          "Tier-1 School": "Tier 1 School",
          "Techie": "Techie",
          "Fortune-500": "Fortune 500 Experience",
          "Unicorns": "Unicorn Experience",
          "S&P 500": "S&P 500",
          "DAX 40": "DAX 40",
          "Big Oil": "Big Oil",
          "DOW 30": "DOW 30",
          "FTSE 100": "FTSE 100",
          "NASDAQ 100": "NASDAQ 100",
          "MAANG": "MAANG",
          "BATX": "BATX",
          "Nifty 50 / Sensex": "Nifty 50 / Sensex",
          "C9 League (China)": "C9 League (China)",
          "U15 Group (Canada)": "U15 Group (Canada)",
          "Ivy League (USA)": "Ivy League (USA)",
          "Group of Eight (Australia)": "Group of Eight (Australia)",
          "Russell Group (UK)": "Russell Group (UK)",
        }

        formattedString += `| Highlights: `;

        for (let i = 0; i < modifedPayload.profilehighlights.length; i++) {
          formattedString += `${MappingObject[modifedPayload.profilehighlights[i]]}`;
          if (i != modifedPayload.profilehighlights.length - 1) {
            formattedString += ', ';
          }
        }
      }
      if(modifedPayload.companies && modifedPayload.companies.length){
        formattedString += ` | Company: ${modifedPayload.companies.map(x=>{x=x.replace('.searchastext','').replace('.aisearch', '');return x;}).join(',')} (${modifedPayload.companytype === 'all' || modifedPayload.companytype === 'All' ? 'Current or Past' : modifedPayload.companytype })`
      }
      if(modifedPayload.industries && modifedPayload.industries.length){
        formattedString = formattedString + ` | Industries: ${modifedPayload.industries.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')} (${modifedPayload.industrytype === 'all' || modifedPayload.industrytype === 'All' ? 'Current or Past' : modifedPayload.industrytype })`
      }
      if(modifedPayload.fromyearsofexperience && modifedPayload.fromyearsofexperience.length &&
         modifedPayload.toyearsofexperience && modifedPayload.toyearsofexperience.length){
          formattedString = formattedString + ` | ${modifedPayload.experiencetype} years of exp:  : ${modifedPayload.fromyearsofexperience[0]} - ${modifedPayload.toyearsofexperience[0]}`
      }
      if(modifedPayload.educationaldegrees && modifedPayload.educationaldegrees.length){
        formattedString = formattedString + ` | Education: ${modifedPayload.educationaldegrees.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }

      if(modifedPayload.educationalmajors && modifedPayload.educationalmajors.length){
        formattedString = formattedString + ` | Field Of Study : ${modifedPayload.educationalmajors.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }

      if(modifedPayload.schools && modifedPayload.schools.length){
        formattedString = formattedString + ` | Schools : ${modifedPayload.schools.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`

      }
      if(modifedPayload.likelytomovetype && modifedPayload.likelytomovetype.toLowerCase() !== 'all'){
        formattedString = formattedString + ` | Likely to Move: ${modifedPayload.likelytomovetype}`
      }

      if(modifedPayload.genders && modifedPayload.genders.length && modifedPayload.genders[0].toLowerCase() != 'all'){
        formattedString = formattedString + ` | Gender: ${this.showGender(modifedPayload.genders[0])}`
      }
      if(modifedPayload.exclude_jobtitles && modifedPayload.exclude_jobtitles.length){
        formattedString = formattedString + ` | Excluded Jobtitles: ${modifedPayload.exclude_jobtitles.map(x=>{x=x.replace('.searchastext','').replace('.aisearch', '');return x;}).join(',')} (${modifedPayload.jobtitletype === 'all' ? 'Current or past' : modifedPayload.jobtitletype})`
      }

      if(modifedPayload.exclude_locations && modifedPayload.exclude_locations.length){
        const location = modifedPayload.locations.filter(l => !l.includes('.iplocation')).map(x => {
          x = x.includes('.aisearch') ? x.split(',')[0].trim() : x;
          x = x.replace('.searchastext','').replace('.iplocation', '').replace('.aisearch', '');
          return x;
        });
        formattedString += location && location.length ? ` | Excluded Location: ${location.join(':')}` : '';;
      }

      if(modifedPayload.exclude_companies && modifedPayload.exclude_companies.length){
        formattedString += ` | Excluded Companies: ${modifedPayload.exclude_companies.map(x=>{x=x.replace('.searchastext','').replace('.aisearch', '');return x;}).join(',')} (${modifedPayload.companytype === 'all' ? 'Current or Past' : modifedPayload.companytype })`
      }

      if (modifedPayload.mandatoryskills && modifedPayload.mandatoryskills.length) {
        formattedString += ` | Mandatory Skills: ${modifedPayload.mandatoryskills.map(x=>{x=x.replace('.searchastext','').replace('.aisearch', '');return x;}).join(', ')}`;
      }

      if (modifedPayload.functions && modifedPayload.functions.length) {
        formattedString += ` | Functions: ${modifedPayload.functions.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')}`;
      }
      if(modifedPayload.exclude_functions && modifedPayload.exclude_functions.length){
        formattedString += ` | Excluded Functions: ${modifedPayload.exclude_functions.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }

      if (_.flatten(modifedPayload.seniority) && Array.isArray(modifedPayload.seniority) && modifedPayload.seniority.length) {

        let mofifiedD =[]
        let data =modifedPayload.seniority.map(item => item.trim())
        if(data.includes("All")){
          mofifiedD = ["All"]
          }else{
            mofifiedD=data;
          }
          if(mofifiedD.length){
            formattedString += ` | Seniority: ${mofifiedD.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')}\n`;
          }
      }
      if (_.flatten(modifedPayload.positionhierarchies) && Array.isArray(modifedPayload.positionhierarchies) && modifedPayload.positionhierarchies.length) {

        let mofifiedD =[]
        let data =modifedPayload.positionhierarchies.map(item => item.trim())
        if(data.includes("All")){
          mofifiedD = ["All"]
          }else{
            mofifiedD=data;
          }
          if(mofifiedD.length){
            formattedString += ` | Webbtree True Level: ${mofifiedD.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')}\n`;
          }
      }
      if (modifedPayload.fullnames && modifedPayload.fullnames.length ) {
        formattedString += ` | Name: ${modifedPayload.fullnames.map(x=>{x=x.replace('.searchastext','');return x;}).join(', ')}\n`;
      }

      if (modifedPayload.changedjobs && modifedPayload.changedjobs === 'yes'){
        formattedString += ` | Changed Jobs: ${modifedPayload.changedjobs}`
      }

      if (modifedPayload.currentfromyearsofexperience && modifedPayload.currentfromyearsofexperience.length &&
        modifedPayload.currenttoyearsofexperience && modifedPayload.currenttoyearsofexperience.length
        ) {
        formattedString += ` |  Years In Current Company :  ${modifedPayload.currentfromyearsofexperience[0]} - ${modifedPayload.currenttoyearsofexperience[0]}\n`;
      }
      if(modifedPayload.exclude_industries && modifedPayload.exclude_industries.length){
        formattedString += ` | Excluded Industry: ${modifedPayload.exclude_industries.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }
      if(modifedPayload.schoollocation && modifedPayload.schoollocation.length){
        formattedString += ` | Education Location: ${modifedPayload.schoollocation.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`
      }
      if(modifedPayload.exclude_schoollocation && modifedPayload.exclude_schoollocation.length){
        formattedString += ` | Excluded Education Location: ${modifedPayload.exclude_schoollocation.map(x=>{x=x.replace('.searchastext','');return x;}).join(',')}`

      }
 if (modifedPayload.fromgraduationyear || modifedPayload.tograduationyear) {
  const from = modifedPayload.fromgraduationyear ?? '';
  const to = modifedPayload.tograduationyear ?? '';

  formattedString += ` | Year of graduation: ${from}${to ? ' - ' + to : ''}`;
}

 if (modifedPayload.screeningCriteria || modifedPayload.screeningCriteria) {


  formattedString += ` | Screening Criteria: ${modifedPayload.screeningCriteria.toString()}`;
}

     if(modifedPayload && modifedPayload.booleanquery){
        if(modifedPayload.booleanquery === '*' && formattedString.length === 0 && modifedPayload.isUploadedFromResume === false && modifedPayload.linkedinurl === ''){
              originalFormattedString = `Search: All |`
        }else{
             if(modifedPayload.booleanquery !== '*'){
                originalFormattedString = ` Search: ${modifedPayload.booleanquery} |`
             }
             if((modifedPayload.booleanquery === '*' || modifedPayload.booleanquery !== '*') && (modifedPayload.isUploadedFromResume === true || modifedPayload.linkedinurl !== '')){
              if(modifedPayload.isUploadedFromResume === true){
                originalFormattedString += ` | Similar Candidates: Resume`;
                  if(modifedPayload.fullname.trim().length){
                    originalFormattedString += ` = ${modifedPayload.fullname}`;
                  }
                }
                if(modifedPayload.linkedinurl != ''){
                  originalFormattedString += ` | Similar Candidates: Linkedin = ${modifedPayload.fullname} `
                }
             }
        }

        originalFormattedString = originalFormattedString + formattedString

      }

      if(!originalFormattedString.includes('Search: All')){
        originalFormattedString = originalFormattedString.replace("|", "")
      }else if(originalFormattedString.includes('Search: All')){
        originalFormattedString = originalFormattedString.replace("|", "")
      }

      if(modifedPayload && modifedPayload?.searchedfrom && modifedPayload.searchedfrom === 'job-description'){
        if(modifedPayload?.nlsearchquery) {
          originalFormattedString = `AI Search Filters | ''` + originalFormattedString.trim();
        } else {
          originalFormattedString = `Job Description Filters | ''` + originalFormattedString.trim();
        }
      }



    }

    return originalFormattedString.trim();
  }

  openHistoryModal() {
    this.starthistory = 0
    this.modalService.open(this.historymodal, { windowClass: "small-modal", centered: true })
    this.gethistory()
  }

  modifyQueryForUi(data){
    return  {
      startindex: data.startindex,
      resultsize: 1,
      searchviaboolean: true,
      booleanquery: data.booleanquery,
      jobtitles: data.jobtitles && data.jobtitles.length ? data.jobtitles.split('; '): [],
      pastjobtitles: data.pastjobtitles && data.pastjobtitles.length ? data.pastjobtitles.split('; '): [],
      preferredskills: data.preferredskills && data.preferredskills.length ? data.preferredskills.split('; '): [],
      mandatoryskills: data.mandatoryskills && data.mandatoryskills.length ? data.mandatoryskills.split('; '): [],
      locations: data.locations && data.locations.length ? data.locations.split('; ') : [],
      companies: data.companies && data.companies.length ? data.companies.split('; '): [],
      industries: data.industries && data.industries.length ? data.industries.split('; ') : [],
      exclusionlist: [],
      genders: data.gender != '' ? data.gender && data.gender.length ? [data.gender] : [] : [],
      seniority: data.seniority && data.seniority.length ? data.seniority.split(";") : [],
      graduationyear: data.graduationyear && data.graduationyear.length ? data.graduationyear.split('; ') : [],
      schools: data.schools && data.schools.length ? data.schools.split('; ') : [],
      schooltypes: [],
      educationaldegrees: data.educationaldegrees && data.educationaldegrees.length ? data.educationaldegrees.split('; ') : [],
      educationalmajors: data.educationalmajors && data.educationalmajors.length ? data.educationalmajors.split('; ') : [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: data.candidateshavingcontactnumbers ? true : false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: data.zipcodes && data.zipcode.length ? data.zipcode : [],
      companysizes: data.companysizes && data.companysizes.length ? data.companysizes.split(";") : [],
      candidateshavingcontacts: data.candidateshavingcontacts ? true : false,
      // workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      // workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      // worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      // spokenlanguages: this.languageSelectedList.map(l => l.key),
      // contacts: this.contacts ? [this.contacts] : [],
      // candidateshavingmobilenumber: this.contactSelectedList.find(c => c.key.toLowerCase() == 'mobile number') ? true : false,
      // candidateshavingpersonalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'personal email') ? true : false,
      // candidateshavingprofessionalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'current professional email') ? true : false,
      // candidateshavingsocialprofiles: this.contactSelectedList.find(c => c.key.toLowerCase() == 'social profiles') ? true : false,
      exclude_jobtitles: data.exclude_jobtitles && data.exclude_jobtitles.length ? data.exclude_jobtitles.split('; '): [],
      exclude_pastjobtitles: data.exclude_pastjobtitles && data.exclude_pastjobtitles.length ? data.exclude_pastjobtitles.split('; '): [],
      exclude_companies: data.exclude_companies && data.exclude_companies.length ? data.exclude_companies.split('; '): [],
      exclude_locations: data.exclude_locations && data.exclude_locations.length ? data.exclude_locations.split('; '): [],
      companytype: data.companytype || null,
      jobtitletype: data.jobtitletype || null,
      industrytype: data.industrytype || null,
      fromyearsofexperience: data.fromyearsofexperience != null ? data.fromyearsofexperience : null,
      toyearsofexperience: data.toyearsofexperience != null ? data.toyearsofexperience : null,
      experiencetype: data.experiencetype,
      likelytomovetype : data.likelytomovetype,
      // salaries : this.salary ? [this.salary] :[]  ,
      // salaryranges : this.salary ? [this.salary] :[],
      talentdiscoveryhistoryid: data.talentdiscoveryhistoryid,
      calledfrom: 'listing',

      isUploadedFromResume: data.isUploadedFromResume ? true : false,
      linkedinurl: (data.linkedinurl !== '' && data.linkedinurl !== undefined && data.linkedinurl !== null ) ? data.linkedinurl : '',
      fullname: data.fullname != '' ? data.fullname : '',
      functions: data?.functions && data?.functions?.length ? data.functions.split('; '): [],
      fullnames: data?.fullnames && data?.fullnames?.length ? data.fullnames.split('; '): [],
      changedjobsstartdurationinmonths: data?.changedjobsstartdurationinmonths || 0,
      changedjobsenddurationinmonths: data?.changedjobsenddurationinmonths || 12,
      distancefromselectedlocationsmeasurementunit: data?.distancefromselectedlocationsmeasurementunit,
      distancefromselectedlocations: data?.distancefromselectedlocations,
      changedjobs: data?.changedjobs,
      currentfromyearsofexperience: data.currentfromyearsofexperience != null ? data.currentfromyearsofexperience : null,
      currenttoyearsofexperience: data.currenttoyearsofexperience != null ? data.currenttoyearsofexperience : null,
      exclude_industries: data.exclude_industries && data.exclude_industries.length ? data.exclude_industries.split(';'): [],
      schoollocation: data.schoollocation && data.schoollocation.length ? data.schoollocation.split(';'): [],
      exclude_schoollocation: data.exclude_schoollocation && data.exclude_schoollocation.length ? data.exclude_schoollocation.split(';'): [],
      profilehighlights: data?.profilehighlights ? data.profilehighlights.split('; ') : [],
      positionhierarchies: data?.positionhierarchies ? data.positionhierarchies.split(';'): [],
      tograduationyear: data.tograduationyear,
      fromgraduationyear: data.fromgraduationyear,
      jdsearchhistoryid: data.jdsearchhistoryid,
      nlsearchquery: data.nlsearchquery,
      exclude_preferredskills: data.exclude_preferredskills && data.exclude_preferredskills.length ? data.exclude_preferredskills.split('; '): [],
      exclude_mandatoryskills: data.exclude_mandatoryskills && data.exclude_mandatoryskills.length ? data.exclude_mandatoryskills.split('; '): [],
      exclude_functions: data.exclude_functions && data.exclude_functions.length ? data.exclude_functions.split('; '): [],
      searchedfrom: data.searchedfrom,
      screeningCriteria: data.screeningCriteria,
      exclude_persons: data.exclude_persons && data.exclude_persons.length ? data.exclude_persons.split('; '): [],
      similarcandidates_excludefirstname: data?.similarcandidates_excludefirstname ? data?.similarcandidates_excludefirstname : '',
      similarcandidates_excludelastname: data?.similarcandidates_excludelastname ? data?.similarcandidates_excludelastname : '',
      similarcandidates_jobtitles: data?.similarcandidates_jobtitles ? data?.similarcandidates_jobtitles.split('; ') : [],
      similarcandidates_companies: data?.similarcandidates_companies ? data?.similarcandidates_companies.split('; ') : [],
    }
  }

  modifyRequestObject(data){
    const userdata = this._localstorageservice.getItem('userdata');
    const preferenceArray = (userdata.preferenceData) ? userdata.preferenceData : [];
    let profilesPerPage;
    preferenceArray.length && preferenceArray.map(item => {
      if (item.listing_type == 'person-search' && item.preference_type == 'page-size') {
        profilesPerPage = item.preference_value;
      }
    })
    return  {
      savehistory: true,
      startindex: data.startindex,
      resultsize: profilesPerPage,
      searchviaboolean: true,
      booleanquery: data.booleanquery,
      jobtitles: data.jobtitles && data.jobtitles.length ? data.jobtitles.split('; '): [],
      pastjobtitles: data.pastjobtitles && data.pastjobtitles.length ? data.pastjobtitles.split('; '): [],
      exclude_pastjobtitles: data.exclude_pastjobtitles && data.exclude_pastjobtitles.length ? data.exclude_pastjobtitles.split(";") : [],
      preferredskills: data.preferredskills && data.preferredskills.length ? data.preferredskills.split('; '): [],
      mandatoryskills: data.mandatoryskills && data.mandatoryskills.length ? data.mandatoryskills.split('; '): [],
      locations: data.locations && data.locations.length ? data.locations.split('; ') : [],
      companies: data.companies && data.companies.length ? data.companies.split('; '): [],
      industries: data.industries && data.industries.length ? data.industries.split('; ') : [],
      exclusionlist: [],
      genders: data.gender != '' ? data.gender && data.gender.length ? [data.gender] : [] : [],
      seniority: data.seniority && data.seniority.length ? data.seniority.split('; ').map(item => item.trim()) : [],
      graduationyear: data.graduationyear && data.graduationyear.length ? data.graduationyear.split('; ') : [],
      schools: data.schools && data.schools.length ? data.schools.split('; ') : [],
      schooltypes: [],
      educationaldegrees: data.educationaldegrees && data.educationaldegrees.length ? data.educationaldegrees.split('; ') : [],
      educationalmajors: data.educationalmajors && data.educationalmajors.length ? data.educationalmajors.split('; ') : [],
      candidateshavingemails: false,
      candidateshavingcontactnumbers: data.candidateshavingcontactnumbers ? true : false,
      minexperience: null,
      maxexperience: null,
      minexperienceinccurrentcompany: null,
      zipcodes: data.zipcodes && data.zipcode.length ? data.zipcode : [],
      companysizes: data.companysizes && data.companysizes.length ? data.companysizes.split('; ').map(item => item.trim()) : [],
      candidateshavingcontacts: data.candidateshavingcontacts ? true : false,
      // workregions: this.currentWorkCitySelectedList.map(wc => wc.key),
      // workcountries: this.currentWorkCountrySelectedList.map(wc => wc.key),
      // worklocalities: this.currentWorkLocalitySelectedList.map(c => c.key),
      // spokenlanguages: this.languageSelectedList.map(l => l.key),
      // contacts: this.contacts ? [this.contacts] : [],
      // candidateshavingmobilenumber: this.contactSelectedList.find(c => c.key.toLowerCase() == 'mobile number') ? true : false,
      // candidateshavingpersonalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'personal email') ? true : false,
      // candidateshavingprofessionalemail: this.contactSelectedList.find(c => c.key.toLowerCase() == 'current professional email') ? true : false,
      // candidateshavingsocialprofiles: this.contactSelectedList.find(c => c.key.toLowerCase() == 'social profiles') ? true : false,
      exclude_jobtitles: data.exclude_jobtitles && data.exclude_jobtitles.length ? data.exclude_jobtitles.split('; ').map(item => item.trim()): [],
      exclude_companies: data.exclude_companies && data.exclude_companies.length ? data.exclude_companies.split('; ').map(item => item.trim()): [],
      exclude_locations: data.exclude_locations && data.exclude_locations.length ? data.exclude_locations.split('; ').map(item => item.trim()): [],
      companytype: data.companytype || null,
      jobtitletype: data.jobtitletype || null,
      industrytype: data.industrytype || null,
      fromyearsofexperience: data.fromyearsofexperience && data.fromyearsofexperience.length  ? data.fromyearsofexperience : [],
      toyearsofexperience: data.toyearsofexperience && data.toyearsofexperience.length ? data.toyearsofexperience : [],
      experiencetype: data.experiencetype,
      likelytomovetype : data.likelytomovetype,
      tograduationyear: data.tograduationyear,
      fromgraduationyear: data.fromgraduationyear,
      // salaries : this.salary ? [this.salary] :[]  ,
      // salaryranges : this.salary ? [this.salary] :[],
      // talentdiscoveryhistoryid: data.talentdiscoveryhistoryid,



      linkedinurl: (data.linkedinurl && data.linkedinurl != '') ? data.linkedinurl : null,
      isUploadedFromResume: (data.isUploadedFromResume && data.isUploadedFromResume == true) ? true : false,
      fullname: (data.fullname && data.fullname !== '') ? data.fullname : '',
      similarcandidates_industries: (data.similarcandidates_industries && data.similarcandidates_industries.length) ? data.similarcandidates_industries.split("; ") : null,
      similarcandidates_locations: (data.similarcandidates_locations && data.similarcandidates_locations.length) ? data.similarcandidates_locations.split("; ") : null,
      similarcandidates_companysizes: (data.similarcandidates_companysizes && data.similarcandidates_companysizes.length) ? data.similarcandidates_companysizes.split("; ") : null,
      similarcandidates_fromyearsofexperience: (data.similarcandidates_fromyearsofexperience && data.similarcandidates_fromyearsofexperience.length) ? data.similarcandidates_fromyearsofexperience.split("; ") : null,
      similarcandidates_toyearsofexperience: (data.similarcandidates_toyearsofexperience && data.similarcandidates_toyearsofexperience.length) ? data.similarcandidates_toyearsofexperience.split("; ") : null,
      // similarcandidates_totaltenure: data.similarcandidates_totaltenure || null,
      exclude_persons: data?.exclude_persons && data?.exclude_persons?.length ? data?.exclude_persons.split('; '): [],
      continentstobeincluded: data.continentstobeincluded.toString().split('; ') || null,
      calledfrom: 'listing',
      functions: data?.functions && data?.functions?.length ? data.functions.split('; '): [],
      fullnames: data?.fullnames && data?.fullnames?.length ? data.fullnames.split('; '): [],
      changedjobsstartdurationinmonths: data?.changedjobsstartdurationinmonths || 0,
      changedjobsenddurationinmonths: data?.changedjobsenddurationinmonths || 12,
      changedjobs: (data?.changedjobs === 'no' && (!(data?.changedjobsstartdurationinmonths) || data?.changedjobsstartdurationinmonths === 0)) ? null : data?.changedjobs,

      distancefromselectedlocationsmeasurementunit: data?.distancefromselectedlocationsmeasurementunit,
      distancefromselectedlocations: data?.distancefromselectedlocations,

      currentfromyearsofexperience: data.currentfromyearsofexperience != null ? data.currentfromyearsofexperience : null,
      currenttoyearsofexperience: data.currenttoyearsofexperience != null ? data.currenttoyearsofexperience: null,


      searchedfrom: (data.searchedfrom && data.searchedfrom != '') ? data.searchedfrom : '',
      exclude_industries: data.exclude_industries && data.exclude_industries.length ? data.exclude_industries.split('; ').map(item => item.trim()): [],

      schoollocation: data.schoollocation && data.schoollocation.length ? data.schoollocation.split(';').map(item => item.trim()): [],
      exclude_schoollocation: data.exclude_schoollocation && data.exclude_schoollocation.length ? data.exclude_schoollocation.split(';').map(item => item.trim()): [],

      needcuratedtalentpooltags: data.needcuratedtalentpooltags ? true : false,
      profilehighlights: data?.profilehighlights ? data?.profilehighlights.split('; ') : [],
      positionhierarchies: data?.positionhierarchies ? data.positionhierarchies.split(';'): [],
      jdsearchhistoryid: data.jdsearchhistoryid,
      nlsearchquery: data.nlsearchquery,
      job_search_keys: data?.job_search_keys,
      exclude_preferredskills: data.exclude_preferredskills && data.exclude_preferredskills.length ? data.exclude_preferredskills.split('; ').map(item => item.trim()): [],
      exclude_mandatoryskills: data.exclude_mandatoryskills && data.exclude_mandatoryskills.length ? data.exclude_mandatoryskills.split('; ').map(item => item.trim()): [],
      exclude_functions: data.exclude_functions && data.exclude_functions.length ? data.exclude_functions.split('; ').map(item => item.trim()): [],
      locationcontinents: data?.locationcontinents,
      screeningCriteria: data?.screeningCriteria ? JSON.parse(data?.screeningCriteria) : {},
      // Re-include the full AI-suggested pool so re-saving history from this page (e.g. auto-triggered search on load) doesn't wipe it out
      screeningCriteriaSuggestions: data?.screeningCriteriaSuggestions ? JSON.parse(data?.screeningCriteriaSuggestions) : {},
      similarcandidates_excludefirstname: data?.similarcandidates_excludefirstname ? data?.similarcandidates_excludefirstname : '',
      similarcandidates_excludelastname: data?.similarcandidates_excludelastname ? data?.similarcandidates_excludelastname : '',
      similarcandidates_jobtitles: data?.similarcandidates_jobtitles ? data?.similarcandidates_jobtitles.split('; ') : [],
      similarcandidates_companies: data?.similarcandidates_companies ? data?.similarcandidates_companies.split('; ') : [],

    }
  }

  private capitalizeFirstLetter(string) {
    if(string && string != null){
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return string;
  }

  private buildExcludedJobTitle(jobtitle : any){
    console.log(jobtitle, 'jobtitlejobtitle')
    jobtitle = jobtitle.split('; ')
    if(jobtitle && jobtitle.length){
      return jobtitle.map(item => {
        return {
          key: item,
          isExcluded: true
        };
      })
    }
  }

  private buildJobTitle(jobtitle : any){
    console.log(jobtitle, 'jobtitlejobtitlejobtitle')

    let jobtitleArray = jobtitle.split('; ')
    return jobtitleArray
    // console.log(jobtitle, 'jobtitlejobtitlejobtitle')
    // if(jobtitleArray && jobtitleArray.length){
    //   console.log(jobtitleArray, 'jobtitleArrayjobtitleArrayjobtitleArray')
    //   jobtitleArray = jobtitleArray.map(item => {
    //     return {
    //       key: item,
    //       isExcluded: false
    //     };
    //   })
    //   console.log(jobtitleArray, 'jobtitleArrayjobtitleArrayjobtitleArray')

    //   return jobtitleArray;
    // }else{
    //   return [];
    // }

  }

  getGenderResult(data: any){
    if(data && data != null){
      data = data.toString().toLowerCase();
      if(data == 'all'){
        return 'All'
      }else if(data == 'male'){
        return 'Male'
      }else if(data == 'female'){
        return 'Female'
      }else if(data == 'not known'){
        return 'Not Known'
      }
    }
    return data
  }

  showGender(data: any){
    if(data && data != null){
      data = data.toString().toLowerCase();
      if(data == 'all'){
        return 'All'
      }else if(data == 'male'){
        return 'Men'
      }else if(data == 'female'){
        return 'Women'
      }else if(data == 'not known'){
        return 'Not Known'
      }
    }
    return data
  }

  editSavedSearch(history) {

    const modalRef = this.modalService.open(SaveSearchModalComponent, { windowClass: "small-modal", centered: true, keyboard: false, backdrop: 'static' });
    modalRef.componentInstance.talentdiscoveryhistoryid = history?.talentdiscoveryhistoryid;
    modalRef.componentInstance.searchName = history?.talentdiscoveryname;
    modalRef.componentInstance.module = this.getHistoryModuleName();
    modalRef.result
    .then((message: any) => {
      if(message === 'user-dismissed') return;
      if(message && message === 'Saved successfully') {
        this.successMessage = 'Search updated successfully';
        this.starthistory = 0;
        this.searchToolboxHistory = [];
        this.gethistory(null, true);
        setTimeout(() => this.successMessage = '', 5000);
      }
    })
    .catch((err: any) => {
      this.errorMessage = 'Something went wrong';
      setTimeout(() => this.errorMessage = '', 5000);
    })
    .finally(() =>{
      // this.starthistory = 0;
      // this.searchToolboxHistory = [];

      this.viewSavedHistoryUpdate.emit('REFRESH');
    } )
  }

  triggerDeleteSaveModal(history) {
    this.savedSearchToDelete = history;
    this.deleteModalRef = this.modalService.open(this.deleteSavedSearchModal, { size :'md' as 'lg', centered: true, keyboard: false, backdrop: 'static' });
    this.deleteModalRef.result.then(() => { this.deleteModalRef = null; this.savedSearchToDelete = null; });
  }

  deleteSavedSearch() {
    if(this.savedSearchToDelete) {
      const payload = {
        talentdiscoveryhistoryid: this.savedSearchToDelete.talentdiscoveryhistoryid,
        issaved: 0
      }
      this.personSearchService.saveSearch(payload, true).subscribe((res: any) => {
        if(res && res.status === 'success') {
          this.deleteModalRef.close();
          this.successMessage = 'Saved search deleted successfully';
          this.starthistory = 0;
          setTimeout(() => this.successMessage = '', 5000);
          this.gethistory(null, true);
        } else {
          this.deleteModalRef.close();
          this.errorMessage = 'Something went wrong';
          setTimeout(() => this.errorMessage = '', 5000);
        }
      }, (err: any) => {
        this.deleteModalRef.close();
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      })
        .add(() => this.viewSavedHistoryUpdate.emit('REFRESH'));
    }
  }

  private getSafeKey(str: string): string {
    return str.toLowerCase().replace(/[^a-zA-Z0-9]/g, '');
  }

  openSaveSearchShareModal(history) {
    const modalRef = this.modalService.open(SaveSearchPersmissionModalComponent, { size: 'lg', backdrop: 'static', keyboard: false, centered: true });
    modalRef.componentInstance.saveSearchName = history.talentdiscoveryname;
    modalRef.componentInstance.saveSearchId = history.talentdiscoveryhistoryid;
    modalRef.componentInstance.module = this.getHistoryModuleName();
    modalRef.result
    .then((res: any) => {
      if(res === 'user-dismissed') return;
      this.successMessage = res;
    })
    .catch((err: any) => {
      this.errorMessage = err;
    })
    .finally(() => {
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 5000);
    });
  }

  getAllTeamMembers() {
    this.loginService.getTagUsers('').subscribe((res: any) => {
        this.members = res?.message || [];
    })
  }
}
